import { useEffect, useState } from 'react';
import GoodsOut from '../../api/controllers/GoodsOut/GoodsOut';
import './DeliveriesIndex.scss';
// import PropTypes from 'prop-types';
import Error from '../../common/Error/Error';
import LoadingSpinner from '../../common/LoadingSpinner/LoadingSpinner';
import Header from '../../common/Header/Header';
import MovementFilter from '../../common/MovementFilter/MovementFilter';
import MovementLine from '../../common/MovementLine/MovementLine';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleInfo } from '@fortawesome/free-solid-svg-icons';

// General DeliveriesIndex Component
const DeliveriesIndex = () => {
  const [deliveries, setDeliveries] = useState();
  const [pagesToDisplay, setPagesToDisplay] = useState();
  const [totalPages, setTotalPages] = useState();
  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  const hubId = JSON.parse(localStorage.getItem('user')).currentHubId;

  const getDeliveries = ({ pageFilter, filter, startDate, endDate }) => {
    setLoading(true);

    const formattedStartDate = startDate.toISOString().split('T')[0];
    const formattedEndDate = endDate.toISOString().split('T')[0];

    GoodsOut.all({
      hubId: hubId,
      category: 'domestic',
      offset: (pageFilter - 1) * 5,
      limit: 5,
      filter: filter,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      sort: 'default',
      order: 'desc',
    })
      .then(response => {
        setDeliveries(response.items);

        const totalPages = Math.ceil(response.total / 5);
        setTotalPages(totalPages);
        const totalPagesArray = Array.from({ length: totalPages }, (v, i) => i + 1);
        const pageIndex = pageFilter - 1;

        setPagesToDisplay(
          totalPagesArray.slice(pageIndex - (pageIndex % 10), pageIndex + 10 - (pageIndex % 10)),
        );

        setLoading(false);
      })
      .catch(e => {
        setLoading(false);
        setError(e.errors || e.error);
      });
  };

  useEffect(() => {
    getDeliveries({
      pageFilter: 1,
      filter: '',
      startDate: new Date(),
      endDate: new Date(new Date().setDate(new Date().getDate() + 1)),
    });
  }, []);

  return (
    <div className="deliveries_index_screen">
      <Header title={'Deliveries'} rightButton={'home'} />
      <div className="deliveries_index_container">
        {error && (
          <Error
            errorMessages={error}
            type={'info'}
            errorTitle={
              Array.isArray(error)
                ? `${error.length} error${error.length > 1 ? 's occurred:' : ' occurred:'} `
                : ''
            }
          />
        )}
        {loading && <LoadingSpinner />}
        <MovementFilter
          pagesToDisplay={pagesToDisplay || []}
          updateList={getDeliveries}
          totalPages={totalPages}
        />
        {deliveries && deliveries.length == 0 && (
          <div className="no_movements">
            <FontAwesomeIcon className="symbol" icon={faCircleInfo} data-testid="info_icon" />
            No deliveries matching current filters
          </div>
        )}
        {deliveries && (
          <div className="deliveries_list">
            {deliveries.map(delivery => (
              <MovementLine movement={delivery} movementType={'deliveries'} key={delivery.id} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// DeliveriesIndex.propTypes = {
// };

export default DeliveriesIndex;
